import { render, staticRenderFns } from "./MedicalContentTemplateInputForm.vue?vue&type=template&id=0868e72d&scoped=true&"
import script from "./MedicalContentTemplateInputForm.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplateInputForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplateInputForm.vue?vue&type=style&index=0&id=0868e72d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868e72d",
  null
  
)

export default component.exports